import axios from "axios";
import { authService } from "../services/authService";
import { CONFIG } from "../config";

const client = axios.create({
  baseURL: CONFIG.api.baseUrl,
  withCredentials: true,
});

const clientFree = axios.create({
  baseURL: CONFIG.api.baseUrl,
  withCredentials: true,
});

function is401Error(error: any) {
  return error.response?.status === 401;
}

function enqueueRequest(originalRequest: any) {
  return new Promise((resolve, reject) => {
    failedQueue.push({ resolve, reject });
  })
    .then(() => {
      return axios(originalRequest);
    })
    .catch((err) => Promise.reject(err));
}

let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (error?: any) => void;
}> = [];

const processQueue = (error: any) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });

  failedQueue = [];
};

// Добавляем счетчик попыток обновления токена
let refreshAttempts = 0;
const MAX_REFRESH_ATTEMPTS = 3;

clientFree.interceptors.response.use(
  (response) => {
    return response;
  }
);

client.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (is401Error(error) && !originalRequest._retry) {
      if (isRefreshing) {
        return enqueueRequest(originalRequest);
      }

      // Проверяем количество попыток обновления токена
      if (refreshAttempts >= MAX_REFRESH_ATTEMPTS) {
        console.log("Превышено максимальное количество попыток обновления токена");
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      isRefreshing = true;
      refreshAttempts++;

      try {
        await authService.refreshToken();
        processQueue(null);
        // Сбрасываем счетчик при успешном обновлении
        refreshAttempts = 0;
        return axios(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export { client, clientFree};
